import { useRepo, Model } from "pinia-orm";
import User from "./User";
import SspCase from "@/models/Case";
import Agency from "./Agency";

export default class Project extends Model {
  static name = "Project";
  static primaryKey = "chronorapso";

  static fields() {
    return {
      uuid: this.uid(""),
      projectId: this.attr(""),
      originId: this.attr(""),
      atlasMethodo: this.string(""),
      autoUpdatedAt: this.string(""),
      updatedAt: this.string(""),
      caseName: this.string(""),
      caseLabel: this.attr(null),
      caseSituation: this.attr(null),
      caseStatus: this.attr(null),
      chronorapso: this.attr(""),
      description: this.string(""),
      contractingAgency: this.belongsTo(Agency, "agencyCode", "code"),
      createdByOldRapso: this.boolean(false),
      dmsStructuration: this.attr(""),
      emittedDocs: this.attr(""),
      isArchived: this.boolean(false),
      isFavorite: this.boolean(false),
      isProjectInBim: this.boolean(false),
      city: this.attr(""),
      projectName: this.string(""),
      userProfileId: this.attr(""),
      caseId: this.attr(""),
      webmailLogin: this.string(""),
      webmailEmail: this.string(""),
      webmailPrimaryId: this.attr(""),
      webmailPassword: this.string(""),
      caseUuid: this.uid(""),
      caseNumber: this.uid(""),
      case: this.belongsTo(SspCase, "caseNumber", "caseNumber"),
      projectEmail: this.string(""),
      managerEmail: this.string(""),
      managerUsermanagementUuid: this.uid(""),
      manager: this.belongsTo(User, "managerUsermanagementUuid", "usermanagementUuid"),
      address: this.string(""),
      postcode: this.string(""),
      receptionDate: this.string(""),
      isNationalContract: this.boolean(false),
      workDescription: this.string(""),
      phase: this.string(""),
      initialAmount: this.number(0),
      estimatedDuration: this.number(0),
      signDate: this.string(""),
      missionAmount: this.string(""),
      mission: this.string(""),
      missionLabel: this.string(""),
      agencyCode: this.string(""),
      agencyName: this.string(""),
      photoDocumentId: this.string(""),
      opeStartDate: this.string(""),
      client: this.string(""),
      clientLabel: this.string(""),
      substituteManagerEmail: this.string(""),
      substituteManagerUsermanagementUuid: this.uid(""),
      otherMissions: this.string(""),
      contactClientMail: this.string(""),
      contactClientUsermanagementUuid: this.attr(null),
      // Champs de contact client spécifiques à la mission
      contactClientCompany: this.string(""),
      contactClientFirstName: this.string(""),
      contactClientLastName: this.string(""),
      contactClientRole: this.string(""),
      contactClientAddress: this.string(""),
      contactClientPostcode: this.string(""),
      contactClientCity: this.string(""),
      contactClientTelephone: this.string(""),
      typology: this.string(""),
      comment: this.string(""),
      oldProjectId: this.string(""),
      lastReportTemplateName: this.string(""),
      lastReportDate: this.string(""),
    };
  }

  static createFromListerData(data) {
    const ProjectRepo = useRepo(this);
    ProjectRepo.save({
      uuid: data.projectUuid,
      projectName: data.rapsoProjectName || data.projectName,
      chronorapso: data.projectChronorapso,
      caseUuid: data.caseUuid,
      caseNumber: data.caseNumber,
      city: data.rapsoCaseCity || data.caseCity,
      updatedAt: data.projectUpdatedAt,
      manager: data.projectManager,
      managerEmail: data.projectManager?.email,
      managerUsermanagementUuid: data.projectManager?.usermanagementUuid,
      isArchived: data.projectIsArchived,
      lastReportTemplateName: data.rapsoLastReportTemplateName || data.lastReportTemplateName,
      lastReportDate: data.rapsoLastReportDate || data.lastReportDate,
      phase: data.rapsoPhase || data.phase,
      clientLabel: data.clientLabel,
      isFavorite: data.isFavorite,
    });
  }

  static PROJECT_PHASE() {
    return {
      PENDING: "En attente",
      CONCEPTION: "En Conception",
      // SPS specific project phase
      REALISATION: "En Réalisation",
      DIUO: "En DIUO",
      DONE: "Terminé",
    };
  }
}
